import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    buttonCancel: {
      border: `1px solid ${palette.gray}`,
      color: palette.gray,
    },
    buttonConfirm: {
      border: `1px solid ${palette.green}`,
      backgroundColor: palette.green,
      color: palette.white,
    },
    buttonsBase: {
      borderTop: `1px solid ${palette.borderGray}`,
      justifyContent: 'right',
      alignItems: 'end',
    },
    buttonsAlign: {
      justifyContent: 'flex-end',
      display: 'flex',
      padding: '10px 0px 5px',
    },
    checkboxCell: {
      padding: '0px 8px !important',

      '& .MuiCheckbox-root': {
        padding: 0,
      },

      '& span > span > svg': { width: 15, height: 15 },
    },
  });
